import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { GlobalStyle } from "./GlobalStyles";
import Header from "./components/header";
import Banners from "./components/banner";
import Businesses from "./components/businesses";
import JindalTyreFeature from "./components/featured/JindalTyreFeature";
import MinggoFeature from "./components/featured/MinggoFeature";
import PlayzoneFeature from "./components/featured/PlayzoneFeature";
import Footer from "./components/footer";
import TyresPage from "./pages/TyresPage";
import MinggoPage from "./pages/MinggoPage";
import RajeshPage from "./pages/RajeshPage";
import PetroworldPage from "./pages/PetroworldPage";
import NamanPage from "./pages/NamanPage";
import AboutPage from "./pages/AboutPage";
import TyreGuidePage from "./pages/TyreGuidePage";
import TyreCareGuidePage from "./pages/TyreCareGuidePage";
import PlayzonePage from "./pages/PlayzonePage";
import './App.css'

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
    } else {
      const id = hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app">
        <GlobalStyle />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<>
              <Banners />
              <Businesses />
              <JindalTyreFeature />
              <MinggoFeature />
              <PlayzoneFeature />
            </>} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/tyres" element={<TyresPage />} />
            <Route path="/tyres/how-to-read-a-tyre" element={<TyreGuidePage />} />
            <Route path="/tyres/tyre-care-guide" element={<TyreCareGuidePage />} />
            <Route path="/minggo" element={<MinggoPage />} />
            <Route path="/rajesh-automobiles" element={<RajeshPage />} />
            <Route path="/petroworld" element={<PetroworldPage />} />
            <Route path="/naman-enterprises" element={<NamanPage />} />
            <Route path="/minggo-playzone" element={<PlayzonePage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
